// extracted by mini-css-extract-plugin
export default {"GridContainer":"SpotlightLayout_GridContainer__yoqe8","Spotlight":"SpotlightLayout_Spotlight__p+N+W"};